import React from 'react';
import PropTypes from 'prop-types';
import { groupBy } from 'lodash';
import { convertTenantIdToObject } from '@a0/support-center-common/lib/tenants';
import '../SubscriptionPreview/module.css';

const MANAGE_URL = 'https://manage.auth0.com';

/**
 * Creates a URL to switch to the correct tenant in manage
 * and redirect to the subscription pricing screen
 *
 * @param {string} tenantId
 * @returns {string} pricing url
 */
export function formatPricingUrl(tenantId) {
  try {
    const { tenantName, tenantLocality } = convertTenantIdToObject(tenantId);
    return `${MANAGE_URL}/dashboard/${tenantLocality}/${tenantName}/tenant/billing/subscription`;
  } catch (e) {
    return `${MANAGE_URL}/#/tenant/billing/subscription`;
  }
}

const SelfServicePreview = ({ subscriptions, withLinks, tenantId, isV8Plan }) => {
  const plans = groupBy(subscriptions, 'name');

  let subscriptionType;
  
  if(isV8Plan){
    if(subscriptions && subscriptions[0] && subscriptions[0].isCustomAgreement){
      subscriptionType = <div>Custom Agreement</div>;
    }
    else {
      subscriptionType = <div>Self Service</div>;
    }
  }
  else {
    subscriptionType = Object.keys(plans).map(plan => (
      <div key={plan}>
        {plan}: {plans[plan].length}
      </div>
    ));
  }

  return (
    <div className="self-service-subscription-preview">
      <div className="row">
        <div styleName="label-group" className="col-xs-6">
          {isV8Plan ? <span>Subscription Type</span> : <span>Subscriptions</span>}
          <div className="plans-list">
            {subscriptionType}
          </div>
        </div>
        <div styleName="label-group" className="col-xs-6">
          <span>Total Tenants</span>
          <div className="total-services">{subscriptions.length}</div>
        </div>
      </div>
      {withLinks && <div className="row">
        <div styleName="label-group" className="col-xs-6">
          <span>Want to upgrade?</span>
          <div>
            <a styleName="arrow-link" href={formatPricingUrl(tenantId)}>
              See Pricing
            </a>
          </div>
        </div>
        <div styleName="label-group" className="col-xs-6">
          <span>Special requirements?</span>
          <div>
            <a styleName="arrow-link" href="mailto:sales@auth0.com">
              Contact Sales
            </a>
          </div>
        </div>
      </div>}
    </div>
  );
};

SelfServicePreview.propTypes = {
  subscriptions: PropTypes.array.isRequired,
  withLinks: PropTypes.bool,
  tenantId: PropTypes.string.isRequired,
  isV8Plan: PropTypes.bool
};

export default SelfServicePreview;
